import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  adminListNewsletterIssues,
  adminSetNewsletterStatus,
} from "../../../../services/admin";

import AdminHeader from "../../../../components/AdminHeader";
import AdminPageHeader from "../../../../components/admin/AdminPageHeader";

const responsiveStyles = `
  @media (max-width: 760px) {
    .editorialHomePage {
      padding: 22px 14px 44px !important;
      max-width: 100% !important;
      box-sizing: border-box !important;
      overflow-x: hidden !important;
    }

    .editorialHomeTopActions {
      margin-bottom: 16px !important;
    }

    .editorialHomePrimaryBtn {
      width: 100% !important;
      justify-content: center !important;
      text-align: center !important;
      box-sizing: border-box !important;
    }

    .editorialHomeList {
      gap: 14px !important;
    }

    .editorialHomeCard {
      display: grid !important;
      grid-template-columns: 1fr !important;
      align-items: stretch !important;
      gap: 14px !important;
      padding: 16px !important;
      border-radius: 18px !important;
    }

    .editorialHomeTitle {
      font-size: 16px !important;
      line-height: 1.35 !important;
      overflow-wrap: anywhere !important;
    }

    .editorialHomeMeta {
      line-height: 1.5 !important;
      overflow-wrap: anywhere !important;
    }

    .editorialHomeActions {
      display: grid !important;
      grid-template-columns: 1fr 1fr !important;
      gap: 10px !important;
      width: 100% !important;
    }

    .editorialHomeActionBtn,
    .editorialHomeActionLink {
      width: 100% !important;
      min-height: 44px !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      box-sizing: border-box !important;
      text-align: center !important;
      border-radius: 12px !important;
    }
  }

  @media (max-width: 390px) {
    .editorialHomeActions {
      grid-template-columns: 1fr !important;
    }
  }
`;

export default function EditorialHome() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const data = await adminListNewsletterIssues();
      setItems(Array.isArray(data?.items) ? data.items : []);
    } catch (e) {
      console.error("[EDITORIAL] load error", e);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const toggleStatus = async (id, current) => {
    const next = current === "published" ? "draft" : "published";
    await adminSetNewsletterStatus(id, next);
    load();
  };

  return (
    <>
      <AdminHeader />
      <style>{responsiveStyles}</style>

      <div className="editorialHomePage" style={{ padding: 40, maxWidth: 1000, margin: "0 auto" }}>
        <AdminPageHeader
          title="Editorial"
          subtitle="Crear, publicar y organizar activos editoriales. El envío por correo se gestiona desde CRM."
          backTo="/admin/produccion"
        />

        <div className="editorialHomeTopActions" style={{ marginBottom: 20 }}>
          <Link to="/admin/produccion/editorial/new" className="editorialHomePrimaryBtn" style={primaryBtn}>
            + Nueva edición
          </Link>
        </div>

        {loading ? (
          <p>Cargando…</p>
        ) : items.length === 0 ? (
          <div style={emptyState}>
            <p style={{ marginBottom: 10 }}>No hay ediciones aún.</p>

            <Link to="/admin/produccion/editorial/new" className="editorialHomePrimaryBtn" style={primaryBtn}>
              Crear primera edición
            </Link>
          </div>
        ) : (
          <div className="editorialHomeList" style={{ display: "grid", gap: 12 }}>
            {items.map((it) => {
              const alreadySent = Boolean(it.newsletter_sent_at);

              return (
                <div key={it.id} className="editorialHomeCard" style={card}>
                  <div>
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
                      <span style={badge(it.status)}>{it.status}</span>

                      {alreadySent && (
                        <span style={sentBadge}>Enviada por correo</span>
                      )}
                    </div>

                    <div className="editorialHomeTitle" style={title}>{it.issue_line || "Sin título"}</div>

                    <div className="editorialHomeMeta" style={meta}>
                      {it.type && <span style={typeBadge(it.type)}>{it.type}</span>}
                      {" "}· slug: {it.slug}
                    </div>

                    {alreadySent && (
                      <div style={sentMeta}>
                        Enviada el {formatDate(it.newsletter_sent_at)}. Sigue visible en ZEDRO News mientras esté publicada.
                      </div>
                    )}
                  </div>

                  <div className="editorialHomeActions" style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                    <Link
                      to={`/admin/produccion/editorial/${it.id}/edit`}
                      className="editorialHomeActionLink"
                      style={secondaryBtn}
                    >
                      Editar
                    </Link>

                    <button
                      type="button"
                      onClick={() => toggleStatus(it.id, it.status)}
                      className="editorialHomeActionBtn"
                      style={ghostBtn}
                    >
                      {it.status === "published" ? "Despublicar" : "Publicar"}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
}

function formatDate(value) {
  if (!value) return "—";

  try {
    return new Date(value).toLocaleDateString("es-CA", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return "—";
  }
}

const card = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 18,
  padding: 16,
  border: "1px solid #e6ebf1",
  borderRadius: 12,
  background: "#fff",
  boxShadow: "0 10px 30px rgba(0,0,0,.05)",
};

const title = {
  fontWeight: 900,
  fontSize: 16,
  color: "#0a2230",
  marginTop: 4,
};

const meta = {
  fontSize: 13,
  color: "#6b7a88",
  marginTop: 4,
};

const sentMeta = {
  marginTop: 6,
  fontSize: 12,
  color: "#64748b",
};

const badge = (status) => ({
  display: "inline-flex",
  alignItems: "center",
  minHeight: 24,
  padding: "0 8px",
  borderRadius: 999,
  fontSize: 12,
  fontWeight: 800,
  color: status === "published" ? "#16a34a" : "#a16207",
  background: status === "published" ? "#ecfdf5" : "#fffbeb",
  border: status === "published" ? "1px solid #bbf7d0" : "1px solid #fde68a",
});

const sentBadge = {
  display: "inline-flex",
  alignItems: "center",
  minHeight: 24,
  padding: "0 8px",
  borderRadius: 999,
  fontSize: 12,
  fontWeight: 800,
  color: "#0f2f46",
  background: "#eef7ff",
  border: "1px solid #cfe6f7",
};

const primaryBtn = {
  padding: "10px 16px",
  borderRadius: 10,
  background: "#286b94",
  color: "#fff",
  fontWeight: 800,
  textDecoration: "none",
  display: "inline-flex",
  alignItems: "center",
};

const secondaryBtn = {
  padding: "8px 12px",
  borderRadius: 8,
  border: "1px solid #ccd2dd",
  background: "#fff",
  fontWeight: 700,
  textDecoration: "none",
  color: "#2c3b51",
};

const ghostBtn = {
  padding: "8px 12px",
  borderRadius: 8,
  border: "none",
  background: "transparent",
  color: "#286b94",
  fontWeight: 700,
  cursor: "pointer",
};

const emptyState = {
  padding: 30,
  border: "1px dashed #e6ebf1",
  borderRadius: 12,
  textAlign: "center",
  background: "#fff",
};

const typeBadge = (type) => ({
  display: "inline-block",
  padding: "2px 8px",
  borderRadius: 6,
  fontSize: 11,
  fontWeight: 800,
  background:
    type === "newsletter"
      ? "#e0f2fe"
      : type === "ebook"
      ? "#ede9fe"
      : type === "workbook"
      ? "#ecfdf5"
      : "#fef3c7",
  color:
    type === "newsletter"
      ? "#0369a1"
      : type === "ebook"
      ? "#5b21b6"
      : type === "workbook"
      ? "#047857"
      : "#92400e",
});
